import React from 'react';

const Spacer = () => {
    return (
        <div className={"spacer"}></div>
    );
}

export default Spacer;
